// ============================================================================
// PhoneInput.jsx — Corelia UI v1.2
// Composant bi-champ (pays + numéro) avec FormLayout & thème form
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";

import FormLayout from "../Forms/FormLayout";
import DropdownList from "../Forms/DropdownList";
import TextField from "../Forms/TextField";

import countries from "../../../data/countries.json";

const PhoneInput = ({
  labelList = "Pays",
  labelChamp = "Numéro",
  value = {},
  onChange,
  width = "100%",
  style = {},
}) => {
  const handleCountryChange = (countryCode) => {
    const selected = countries.find((c) => c.value === countryCode);
    onChange({
      ...value,
      country: countryCode,
      countryCode: selected?.dialCode || "",
    });
  };

  const handleNumberChange = (e) => {
    const clean = e.target.value.replace(/\D/g, "");
    onChange({ ...value, phoneNumber: clean });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: theme.spacing.xl,
        alignItems: "flex-start",
        width,
        ...style,
      }}
    >
      {/* Champ : Pays */}
      <FormLayout
        label={labelList}
        labelPosition="left"
        labelWidth={110}
        align="center"
        width={260}
      >
        <DropdownList
          options={countries.map((c) => ({
            value: c.value,
            label: `${c.label} (${c.dialCode})`,
          }))}
          value={value.country || "FR"}
          onChange={handleCountryChange}
          width="100%"
        />
      </FormLayout>

      {/* Champ : Numéro */}
      <FormLayout
        label={labelChamp}
        labelPosition="left"
        labelWidth={110}
        align="center"
        width={260}
      >
        <TextField
          placeholder="ex : 612345678"
          value={value.phoneNumber || ""}
          onChange={handleNumberChange}
          width="100%"
        />
      </FormLayout>
    </div>
  );
};

export default PhoneInput;
